import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import Modal from "react-modal";
import { Bars } from "react-loader-spinner";

import {transferAsset} from "../../utils/backendUtils";

import CancelIcon from "../../assets/cancel_icon.svg";
import BidSuccess from "../../assets/bid_success.svg";

const HeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
`

const InfoSpan = styled.div`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  opacity: 0.45;
`


const ActionButtonDiv = styled.div`
  width: 398px;
  width: 100%;
  height: 44px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 30px;
`

const ActionButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const SuccessTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  color: #FFFFFF;
`
export default function TransferComponent(props) {

    let modalWidth = "446px";
    let modalHeight = "285px";
    
    const [showLoader, setShowLoader] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(()=>{
        setError('');
        setSuccess(false);
    },[props.isOpen])

    const transferClicked = async () => {
        setShowLoader(true);
        let resp = await transferAsset(props.item._id, props.itemType);
        if(!resp.success){
            setError('Failed, Please try again later')
            setTimeout(()=>{
                setError('')
            },10*1000)
        }
        else{
            setSuccess(true);
        }
        setShowLoader(false);
    }
    
    return (
        <>
            <Modal
	        isOpen={props.isOpen}
	        style={{
		    content: {
		        background: "#0F0F0F",
		        maxWidth: modalWidth,
		        height: modalHeight,
		        marginLeft: "auto",
		        marginRight: "auto",
		        marginTop: "auto",
		        marginBottom: "auto",
		        border:"none",
		    }
	        }}
	    >
                <div style={{marginLeft:24, marginTop:30,
			     marginRight:24, marginBottom:30,
			     position: "relative"
		}}>
                    <img onClick={()=>{props.handleModalCloseEvent()}}
		         src={CancelIcon}
		         style={{
			     position: "absolute", opacity: 0.4,
			     height: 14, width:14,
			     right:10, cursor:"pointer",
			     zIndex:10
		         }}
		    />
                    {!(success) && (
                        <>
                            <HeaderSpan>
                                Transfer Asset
                            </HeaderSpan>
                            <InfoSpan style={{marginTop:10, width: '100%', overflowWrap: 'anywhere'}}>
                                This action is permanent, please be careful<br/>
                                {/* Transferring #{props.item.serial} to <br/> */}
                                {props.publicAddress}
                            </InfoSpan>
                            {!error && (
                                <ActionButtonDiv onClick={()=>{
                                    transferClicked()}}>
                                    {(!showLoader)  && (
                                        <ActionButtonTextSpan>
                                            Transfer
                                        </ActionButtonTextSpan>
                                    )}
                                    {(showLoader)  && (
                                        <Bars
                                            heigth="30" width="30"
                                            color="grey"
                                            ariaLabel="loading-indicator" />
                                    )}
                                </ActionButtonDiv>
                            )}
                            {error && (
                                <ActionButtonDiv>
                                    <InfoSpan style={{color:'red', opacity:1}}>
                                        {error}
                                    </InfoSpan>
                                </ActionButtonDiv>
                            )}
                        </>
                    )}
                    {(success) && (
                        <div style={{
                            display:'flex',
                            justifyContent:'center',
                            alignItems: 'center',
                            flexDirection: 'column'
                        }}>
                            <img src={BidSuccess} style={{
                                marginTop:32,
                                height:50,
                                width:50
                            }} />
                            <SuccessTextSpan style={{marginTop:21}}>
                                Transfer Started
                            </SuccessTextSpan>
                        </div>   
                    )}
                </div>
            </Modal>
        </>
    );
}
